import { Link, useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { formatDate, getMonthDescription } from "../../common/utils/utils";

const ContractDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userSantias } = useOutletContext<{ userSantias: any }>();

  interface Card {
    identityDocument: string;
    identityDocumentTypeId: number;
    memberCode: number;
    contractId: number;
    contractNumber: string;
    planId: number;
    planName: string;
    insureFromContract: string;
    insureFrom: string;
    insureTo: string;
    contractStatusId: number;
    contractStatus: string;
    monthRenueva: number | null;
    planCategoryId: number;
    planCategory: string;
    paymentPeriodicityId: number;
    paymentPeriodicty: string;
    planTypeId: number;
    planType: string;
    subProductTypeId: number;
    subProductType: string;
    gracePeriodId: number;
    producTypeId: number;
    producType: string;
    cardProviderId: number | null;
    cardProviderDescription: string;
    excludedShortage: string | null;
    antiquity: number;
    clientId: number;
    client: string;
    brokerId: number;
    broker: string;
    gracePeriod: string;
    compositionFamily: number;
    medicalConditions: string;
    lastUpdate?: string;
    statusDate: string;
  }
  interface Payload {
    card?: Card;
  }
  const payload = location.state?.payload || userSantias;
  const cardString = localStorage.getItem("userContrarDetail");
  const card = cardString ? JSON.parse(cardString || '{}') : null;
  const updatedPayload: Payload = { ...payload, card };
  const documentonumero = userSantias.identityDocument;
  const tipodedoc = userSantias.identityDocumentTypeId;

  const handleFamilyCompositionClick = () => {
    navigate("/mi-perfil/composicion-familiar", { state: { payload: updatedPayload, documentonumero, tipodedoc } });
  };

  const handleMedicalConditionsClick = () => {
    navigate("/mi-perfil/condiciones-medicas", { state: { payload: updatedPayload, documentonumero, tipodedoc } });
  };

  const handleBack = () => {
    navigate("/mi-perfil/contratos");
  };

  return (
    <>
      <section className="hero">
        <div className="padding-global">
          <div className="padding-section-small">
            <div className="container-medium">
              <div className="hero_wrp">
                <div className="hero_box is-ajuste">
                  <div className="title-component">
                    <h1 className="title">Datos de contrato</h1>
                    <div className="line-title"></div>
                  </div>
                </div>
                <img
                  src={`/documents/d/guest/Group-7923_1`}
                  loading="lazy"
                  alt=""
                  className="banner_person"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="info-h">
        <div className="padding-global">
          <div className="padding-section-medium">
            <div className="container-large">
              <div className="info_wrp is-left">
                <div className="banner_actualizar dp">
                  <img
                    src={`/documents/d/guest/actualizar-1`}
                    loading="lazy"
                    alt=""
                    className="banner_actualizar-icon"
                  />
                  <div>Última actualización: {formatDate(updatedPayload?.card?.lastUpdate || "")}</div>
                </div>
                <div className="info_inputs w-form">
                  <form
                    id="email-form"
                    name="email-form"
                    data-name="Email Form"
                    method="get"
                    className="datos_form-contrato"
                    data-wf-page-id="66eb1942789a653f9ad8fca1"
                    data-wf-element-id="b67053ef-4d82-68f7-a835-2cf9ebdffd22"
                  >
                    <div className="info_row dp dc">
                      <img
                        src={`/documents/d/guest/Vector-1_1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.contractNumber}
                        </div>
                        <div className="info_input-text dp">N° Contrato</div>
                      </div>
                    </div>
                    <div className="info_row dp dc">
                      <img
                        src={`/documents/d/guest/usuario-4-1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.producType}
                        </div>
                        <div className="info_input-text dp">
                          Tipo de producto
                        </div>
                      </div>
                    </div>
                    <div
                      id="w-node-_5217ba2c-3885-4afb-3f84-27987f156ee7-9ad8fca1"
                      className="info_row dp dc"
                    >
                      <img
                        src={`/documents/d/guest/dias-del-calendario-11-1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.insureFromContract}
                        </div>
                        <div className="info_input-text dp">
                          Inicio de contrato
                        </div>
                      </div>
                    </div>
                    <div
                      id="w-node-_3d9c87f3-ae29-7ba5-47fa-f8874aac36e9-9ad8fca1"
                      className="info_row dp dc"
                    >
                      <img
                        src={`/documents/d/guest/factura-de-mano-3-1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.paymentPeriodicty}
                        </div>
                        <div className="info_input-text dp">
                          Periodicidad de Pago
                        </div>
                      </div>
                    </div>
                    <div
                      id="w-node-ee9a9f54-e02f-a936-3b6a-c364f94e4455-9ad8fca1"
                      className="info_row dp dc"
                    >
                      <img
                        src={`/documents/d/guest/dias-del-calendario-11-1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.insureFrom}
                        </div>
                        <div className="info_input-text dp">
                          Inicio de vigencia del usuario
                        </div>
                      </div>
                    </div>
                    <div
                      id="w-node-d231593f-a4af-9ca0-53e5-922667683b97-9ad8fca1"
                      className="info_row dp dc"
                    >
                      <img
                        src={`/documents/d/guest/firma-del-archivo-4-1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.contractStatus}
                        </div>
                        <div className="info_input-text dp">
                          Estado de contrato
                        </div>
                      </div>
                    </div>
                    <div
                      id="w-node-f6163b73-26d5-3cd1-425a-9c405b08e213-9ad8fca1"
                      className="info_row dp dc"
                    >
                      <img
                        src={`/documents/d/guest/dias-del-calendario-11-1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {getMonthDescription(updatedPayload?.card?.monthRenueva ?? 0)}
                        </div>
                        <div className="info_input-text dp">
                          Mes de renovación
                        </div>
                      </div>
                    </div>
                    <div
                      id="w-node-c2b1209f-9471-2a46-7972-fdf41b97ded1-9ad8fca1"
                      className="info_row dp dc"
                    >
                      <img
                        src={`/documents/d/guest/corporativo-1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.planName}
                        </div>
                        <div className="info_input-text dp">Plan</div>
                      </div>
                    </div>
                    <div
                      id="w-node-cbb545e4-24ac-3f92-01ae-7f866018573d-9ad8fca1"
                      className="info_row dp dc"
                    >
                      <img
                        src={`/documents/d/guest/documento-firmado-1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.producType}
                        </div>
                        <div className="info_input-text dp">
                          Categoría de plan
                        </div>
                      </div>
                    </div>
                    <div
                      id="w-node-d16641b7-feeb-2b6a-9cc2-6a479b3fe7f7-9ad8fca1"
                      className="info_row dp dc"
                    >
                      <img
                        src={`/documents/d/guest/archivo-de-clip-1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.planType}
                        </div>
                        <div className="info_input-text dp">Tipo de plan</div>
                      </div>
                    </div>
                    <div
                      id="w-node-cc69cd51-aad1-0f73-132c-83d00ff68d90-9ad8fca1"
                      className="info_row dp dc"
                    >
                      <img
                        src={`/documents/d/guest/corporativo-1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.compositionFamily} afiliado(s)
                        </div>
                        <div className="info_input-text dp">
                          Composición Familiar
                        </div>
                      </div>
                      <a onClick={handleFamilyCompositionClick} className="info_tezt">
                        ver más
                      </a>
                    </div>
                    <div
                      id="w-node-ed73f9b3-7e0f-7a66-d95a-7f9f51e7712f-9ad8fca1"
                      className="info_row dp dc"
                    >
                      <img
                        src={`/documents/d/guest/Vector-3`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.cardProviderDescription}
                        </div>
                        <div className="info_input-text dp">
                          Débito atomático
                        </div>
                      </div>
                    </div>
                    <div
                      id="w-node-_61e281a8-cb38-7fb7-b38e-cd84d18dd8f3-9ad8fca1"
                      className="info_row dp dc"
                    >
                      <img
                        src={`/documents/d/guest/dias-del-calendario-11-1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.gracePeriod}
                        </div>
                        <div className="info_input-text dp">Carencia</div>
                      </div>
                    </div>
                    <div
                      id="w-node-_815e3b4d-5bf9-535a-ab10-a4476e95fe78-9ad8fca1"
                      className="info_row dp dc"
                    >
                      <img
                        src={`/documents/d/guest/corporativo-1`}
                        loading="lazy"
                        alt=""
                        className="banner_flex-inputs-icon"
                      />
                      <div className="info_input-bx">
                        <div className="info_inputv d-contrato w-input">
                          {updatedPayload?.card?.medicalConditions}
                        </div>
                        <div className="info_input-text dp">
                          Condiciones Médicas
                        </div>
                      </div>
                      <a onClick={handleMedicalConditionsClick} className="info_tezt">
                        ver más
                      </a>
                    </div>
                  </form>
                  <div className="w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div className="w-form-fail">
                    <div>
                      Oops! Something went wrong while submitting the form.
                    </div>
                  </div>
                </div>
                <div className="info_form-btns">
                    <div className="dp_block-btn">
                      <a onClick={handleBack} className="button is-outline is-movile w-button">Atrás</a>
                    </div>
                    <div id="w-node-_24e1b08d-8be0-3871-4a78-0b48d96888a3-c3d90c62" className="dp_block-btn">
                      {updatedPayload?.card?.statusDate === "V" && (<a className="button w-button" href={"/group/guest/constancias-y-reportes"} data-senna-off="true">Contancias y reportes</a>)}                      
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContractDetail;
